export default "__VITE_ASSET__DNhy6ZwO__"